import { useT } from "../i18n/hooks.ts";
import { Dialog } from "./Dialog.tsx";

/**
 * Confirmation before a permanent delete (sub-basin/zone/outlet
 * point/aquifer — see projectEntities.ts): there's no undo, so every delete
 * action goes through here instead of deleting on the first click. If the
 * element comes from a GIS layer, the only thing recoverable afterward is
 * re-importing/redrawing that geometry — without whatever configuration it
 * had (zone, topology, adjustments...), which has to be redone by hand.
 */
export function ConfirmDeleteDialog({
  title,
  name,
  message,
  onConfirm,
  onClose,
}: {
  title: string;
  name: string;
  /** Overrides the default text (aimed at sub-basin/zone/outlet/aquifer) — for deletes of another kind, like an entire saved project. */
  message?: string;
  onConfirm: () => void;
  onClose: () => void;
}) {
  const t = useT();
  return (
    <Dialog title={title} onClose={onClose}>
      <p>{message ?? t("confirmDelete.defaultMessage", { name })}</p>
      <div className="dialog-actions">
        <button
          className="button button-danger"
          onClick={() => {
            onConfirm();
            onClose();
          }}
        >
          {t("confirmDelete.deletePermanently")}
        </button>
        <button className="button" onClick={onClose}>
          {t("common.cancel")}
        </button>
      </div>
    </Dialog>
  );
}
